import { Grid, Skeleton } from 'components/atoms';

const CreateTaskTemplateLoading = () => {
  return (
    <Grid container spacing={3} justify="flex-end">
      <Grid item xs={6}>
        <Skeleton height="57px" />
      </Grid>
      <Grid item xs={6}>
        <Skeleton height="57px" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton height="57px" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton height="57px" />
      </Grid>
      <Grid item xs={12}>
        <Skeleton height="57px" />
      </Grid>
    </Grid>
  );
};

export default CreateTaskTemplateLoading;
